import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import {
  Link,
  Route,
  Switch,
  withRouter,
} from 'react-router-dom';
import MediaQuery from 'react-responsive';
import BackArrow from '../Button/BackArrow';

import './styles.css';
import Currency from '../Currency';
import PersonalInfo from './PersonalInfo';
import BankLinks from './BankLinks';
import Restrictions from './Restrictions';
import Tooltip from '../Tooltip';
import OfferWatches from '../OfferWatches';
import Suitability from '../Suitability';
import AccountNumberInformation from './AccountNumberInformation';
import { LAYOUT, MIN_WIDTH } from '../Layout/enums';

const AccountInformation = ({ layout, accountNumber }) => (
  <Fragment>
    <Restrictions layout={layout} accountNumber={accountNumber} />
    <PersonalInfo layout={layout} />
    <AccountNumberInformation layout={layout} accountNumber={accountNumber} />
    <BankLinks layout={layout} accountNumber={accountNumber} />
  </Fragment>
);

export const routes = [
  { path: '', Comp: AccountInformation },
  { path: 'offer-watches', Comp: OfferWatches },
  { path: 'suitability', Comp: Suitability },
];

export const CashGroup = ({
  cashBalance,
  balanceWithheld,
  accountNumber,
  styleSuff,
  pendingTransfers,
  suitabilityInformationId,
}) => (
  <div>
    <div styleName="cashAvailable">
      <div styleName="flexRow">
        <div styleName={`labelGrey${styleSuff}`}>My IPO Cash Balance</div>
        <div styleName="tooltip">
          <Tooltip text="Balance before pending transfers and pending investments." />
        </div>
      </div>
      <Currency styleName={`labelCash${styleSuff}`} amount={cashBalance} />
    </div>
    <div styleName="pendingRow">
      <div styleName="pendingText">Pending Cash Transfers</div>
      <Currency styleName="pendingText" amount={pendingTransfers} />
    </div>
    <div styleName="pendingRow">
      <div styleName="pendingText">Pending Investments</div>
      <Currency styleName="pendingText" amount={balanceWithheld} />
    </div>
    <div styleName="cashBreak" />
    <div styleName={`cashLinkGroup${styleSuff}`}>
      <Link styleName={`linkLarge${styleSuff}`} to={`/account/${accountNumber}`}>Account Information</Link>
      {!_.isEmpty(suitabilityInformationId) ?
      (<Link styleName={`linkLarge${styleSuff}`} to={`/account/${accountNumber}/suitability`} >Suitability Information</Link>)
      : ('')}
      <Link styleName={`linkLarge${styleSuff}`} to={`/transfers/${accountNumber}`}>Transfer Funds</Link>
      <Link styleName={`linkLarge${styleSuff}`} to={`/account/${accountNumber}/offer-watches`}>Indications of Interest</Link>
      <Link styleName={`linkLarge${styleSuff}`} to={`/account/${accountNumber}/docs`} >Statements and Documents</Link>
      <Link styleName={`linkLarge${styleSuff}`} to={`/account/${accountNumber}/password`} >Change Password</Link>
      <Link styleName={`linkLarge${styleSuff}`} to={`/user/${accountNumber}/upload-dl`} >Upload Driver License</Link>
    </div>
  </div>
);

class ManageAccount extends Component {
  getComponent(layout) {
    const {
      cashBalance,
      accountNumber,
      balanceWithheld,
      pendingTransfers,
      suitabilityInformationId,
    } = this.props;
    if (_.isEmpty(suitabilityInformationId)) {
      const index = routes.indexOf(route => route.path === 'suitability');
      if (index >= 0) {
        routes.slice(index, 1);
      }
    }
    let styleSuff = '';
    switch (layout) {
      case LAYOUT.TAB:
        styleSuff = 'Tab';
        break;
      case LAYOUT.MOB:
        styleSuff = 'Mob';
        break;
      // no default
    }
    const passPropChild = {
      layout,
      styleSuff,
      ...this.props,
    };
    return (
      <div styleName={`flexMain${styleSuff}`}>
        <div styleName="accountLeft">
          <CashGroup
            accountNumber={accountNumber}
            cashBalance={cashBalance}
            balanceWithheld={balanceWithheld}
            pendingTransfers={pendingTransfers}
            styleSuff={styleSuff}
            suitabilityInformationId={suitabilityInformationId}
          />
        </div>
        <div styleName={`accountRight${styleSuff}`}>
          {routes.map(({ path, Comp }) => (
            <Switch>
              <Route
                key={path}
                exact
                path={`${this.props.match.url}/${path}`}
                render={() => <Comp {...passPropChild} />}
              />
            </Switch>
          ))}
        </div>
      </div>
    );
  }

  render() {
    return (
      <div styleName="manageAccount">
        <div styleName="pageContainer">
          <div styleName="backArrow" >
            <BackArrow to="/portfolio" label="Summary" />
          </div>
          <MediaQuery
            minWidth={MIN_WIDTH.DESK}
          >
            {this.getComponent(LAYOUT.DESK)}
          </MediaQuery>
          <MediaQuery
            minWidth={MIN_WIDTH.TAB}
            maxWidth={MIN_WIDTH.DESK - 1}
          >
            {this.getComponent(LAYOUT.TAB)}
          </MediaQuery>
          <MediaQuery
            maxWidth={MIN_WIDTH.TAB - 1}
          >
            {this.getComponent(LAYOUT.MOB)}
          </MediaQuery>
        </div>
      </div>
    );
  }
}

ManageAccount.propTypes = {
  accountNumber: PropTypes.string,
  cashBalance: PropTypes.number,
  balanceWithheld: PropTypes.number,
  pendingTransfers: PropTypes.number,
  suitabilityInformationId: PropTypes.string,
};

ManageAccount.defaultProps = {
  accountNumber: 'unknown',
  cashBalance: null,
  balanceWithheld: null,
  pendingTransfers: null,
  suitabilityInformationId: null,
};

export default withRouter(ManageAccount);



// WEBPACK FOOTER //
// ./src/components/ManageAccount/ManageAccount.js